import { z } from 'zod';

import { parseRateInput } from '@/entities/service-catalog';

// Every field is a string, `''` meaning empty — `undefined` would restore react-hook-form's
// `defaultValues` instead of refusing the submit, as `saveServiceFormSchema` is shaped.
export const editSessionFeeFormSchema = z
    .object({
        serviceCode: z.string().trim().min(1),
        fee: z.string().trim().min(1, 'Enter a fee'),
    })
    .transform((value) => ({
        serviceCode: value.serviceCode,
        feeCents: parseRateInput(value.fee),
    }));

export type EditSessionFeeFormValues = z.input<typeof editSessionFeeFormSchema>;
export type EditSessionFeeFormOutput = z.output<typeof editSessionFeeFormSchema>;
